<script setup lang="ts"></script>

<template>
  <!-- guard position: relative -->
  <div>
    <div :class="$style.popup">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
.popup {
  $arrow-height: 12px;

  position: relative;
  margin-bottom: $arrow-height;
  padding: 16px 24px;
  background: $color-surface-primary;
  border-radius: $border-radius-rounder;
  filter: drop-shadow(0px 2px 6px $color-shadow);

  &::before {
    content: '';
    position: absolute;
    display: block;
    top: 100%;
    left: 50%;
    width: 24px;
    height: $arrow-height;
    background-color: $color-surface-primary;
    transform: translateX(-50%);
    clip-path: polygon(0 0, 100% 0, 50% 100%);
  }

  @include small-mobile-only {
    padding: 12px;
    padding-left: 18px;
  }
}
</style>
